import React, { useContext } from 'react';
import { Util, FormProvider } from '@thinkwell/react.common';
import { AppProvider, TextField } from '@thinkwell/react.polaris';
import ProxyForm from './ProxyForm'

export default function Login(props) {
  Util.hideLoader();

  const showRecover = () => {
    window.location.replace('/account/login?recover#recover');
  }

  const checkout_url = Util.getParam(window.location.href, 'checkout_url')
  const proxyUrl = `https://${props.host}/accounts/login?shop_name=${props.shop_name}${checkout_url ? `&checkout_url=${checkout_url}` : ''}`
  const registerUrl = `/account/register${checkout_url ? `?checkout_url=${checkout_url}` : ''}`
  return (<AppProvider><div>
    <FormProvider><ProxyForm
    action={`/account/login${checkout_url ? `?checkout_url=${checkout_url}` : ''}`}
    submitText="Sign In"
    proxy={{url: proxyUrl}}
    bottomLink={{href: registerUrl, text: "Register a New Account"}}>
      <input readOnly type="hidden" name="form_type" value="customer_login" />
      <TextField
        label="Email"
        id="customer_email"
        name="customer[email]"
      />
      <TextField
        label="Password"
        id="customer_password"
        name="customer[password]"
        type="password"
      />
      <p><a href="#" onClick={showRecover}>Forgot your password?</a></p>
    </ProxyForm></FormProvider>
  </div></AppProvider>)
}
